const WorkWidth = 360;

export const vw = (width: number) => {
  return `${(100 * width) / WorkWidth}vw`;
};
